import { onSnapshot, orderBy, query } from 'firebase/firestore';
import { makeSubcollection } from './subcollection';
import { deletePlayerEverywhere } from './tournamentStages';

// Roster for a tournament, at `tournaments/{id}/players`.
const players = makeSubcollection('players');

export const listPlayers = (tournamentId) => players.list(tournamentId);
export const getPlayer = (tournamentId, playerId) => players.get(tournamentId, playerId);
export const createPlayer = (tournamentId, data) => players.create(tournamentId, data);
export const updatePlayer = (tournamentId, playerId, data) =>
  players.update(tournamentId, playerId, data);
export const deletePlayer = (tournamentId, playerId) => players.remove(tournamentId, playerId);

// Removes an entry from the roster and from every stage (see
// deletePlayerEverywhere). `stageList` = the tournament's current stages.
export const removePlayerFromTournament = (tournamentId, playerId, stageList) =>
  deletePlayerEverywhere(tournamentId, players.ref(tournamentId, playerId), stageList);

// Point a player at a team (or clear it). Used by the team-cumulative flow,
// which mirrors team membership onto player docs.
export const setPlayerTeam = (tournamentId, playerId, teamId) =>
  players.update(tournamentId, playerId, { teamId: teamId || null });

// Ordered variant when a stable roster order is wanted.
export const listPlayersByName = (tournamentId) => players.list(tournamentId, orderBy('name'));

// Live roster, ordered by name. Returns the unsubscribe function.
export const subscribePlayers = (tournamentId, onData, onError) =>
  onSnapshot(
    query(players.col(tournamentId), orderBy('name')),
    (snap) => onData(snap.docs.map((d) => ({ id: d.id, ...d.data() }))),
    onError
  );

export { players as playersCollection };
